import { IconRenderer } from '../IconRenderer';

interface Props {
  title?: string;
  body?: string;
  close?: string;
  onClick?: () => void;
}

export const UnexpectedErrorWebsheet = ({
  title,
  body,
  close,
  onClick,
}: Props) => {
  return (
    <div className="flex flex-col items-center h-full text-center p-6 bg-white">
      <div className="flex flex-col items-center justify-center flex-1 gap-[12px]">
        <figure
          className="max-w-[90px] w-full mx-auto"
          style={{ '--color-error-message': '#9CA3AF' } as React.CSSProperties}
        >
          <IconRenderer variant="error" app="websheet" color="text-gray-200" />
        </figure>
        <h1 className="font-inter! text-2xl text-gray-800 font-bold text-center">
          {title}
        </h1>
        <p className="font-inter! text-base text-gray-600 text-center">
          {body}
        </p>
      </div>
      {onClick && (
        <div className="w-full">
          <button
            type="button"
            onClick={onClick}
            className="font-inter! rounded-lg bg-gray-800 text-center w-full text-white leading-0 h-[40px] flex items-center justify-center cursor-pointer font-normal"
          >
            {close}
          </button>
        </div>
      )}
    </div>
  );
};
